export const states = [
    {
        "name": "Boulkiemde",
        "isoCode": "BOU",
        "countryCode": "BF",
        "latitude": "12.337375",
        "longitude": "-2.223667"
    },
    {
        "name": "Kénédougou",
        "isoCode": "KEN",
        "countryCode": "BF",
        "latitude": "11.39193950",
        "longitude": "-4.97665400"
    },
    {
        "name": "Namentenga",
        "isoCode": "NAM",
        "countryCode": "BF",
        "latitude": "13.08125840",
        "longitude": "-0.52578230"
    },
    {
        "name": "Nahouri",
        "isoCode": "NAO",
        "countryCode": "BF",
        "latitude": "11.25022670",
        "longitude": "-1.13530200"
    },
    {
        "name": "Passoré",
        "isoCode": "PAS",
        "countryCode": "BF",
        "latitude": "12.88812210",
        "longitude": "-2.22366670"
    },
    {
        "name": "Zoundwéogo",
        "isoCode": "ZOU",
        "countryCode": "BF",
        "latitude": "11.61411740",
        "longitude": "-0.98206680"
    },
    {
        "name": "Sissili",
        "isoCode": "SIS",
        "countryCode": "BF",
        "latitude": "11.24412190",
        "longitude": "-2.22366670"
    },
    {
        "name": "Banwa",
        "isoCode": "BAN",
        "countryCode": "BF",
        "latitude": "12.13230530",
        "longitude": "-4.15137640"
    },
    {
        "name": "Bougouriba",
        "isoCode": "BGR",
        "countryCode": "BF",
        "latitude": "10.87226460",
        "longitude": "-3.33889170"
    },
    {
        "name": "Gnagna",
        "isoCode": "GNA",
        "countryCode": "BF",
        "latitude": "12.89749920",
        "longitude": "0.07467670"
    },
    {
        "name": "Mouhoun",
        "isoCode": "MOU",
        "countryCode": "BF",
        "latitude": "12.14323810",
        "longitude": "-3.33889170"
    },
    {
        "name": "Yagha",
        "isoCode": "YAG",
        "countryCode": "BF",
        "latitude": "13.35761570",
        "longitude": "0.75328090"
    },
    {
        "name": "Sanmatenga",
        "isoCode": "SMT",
        "countryCode": "BF",
        "latitude": "13.35653040",
        "longitude": "-1.05861350"
    },
    {
        "name": "Tapoa",
        "isoCode": "TAP",
        "countryCode": "BF",
        "latitude": "12.24970720",
        "longitude": "1.67606910"
    },
    {
        "name": "Houet",
        "isoCode": "HOU",
        "countryCode": "BF",
        "latitude": "11.13204470",
        "longitude": "-4.23333550"
    },
    {
        "name": "Zondoma",
        "isoCode": "ZON",
        "countryCode": "BF",
        "latitude": "13.11659260",
        "longitude": "-2.42087130"
    },
    {
        "name": "Boulgou",
        "isoCode": "BLG",
        "countryCode": "BF",
        "latitude": "11.43367660",
        "longitude": "-0.37483540"
    },
    {
        "name": "Komondjari",
        "isoCode": "KMD",
        "countryCode": "BF",
        "latitude": "12.71265270",
        "longitude": "0.67730460"
    },
    {
        "name": "Koulpélogo",
        "isoCode": "KOP",
        "countryCode": "BF",
        "latitude": "11.52476740",
        "longitude": "0.14949880"
    },
    {
        "name": "Tuy",
        "isoCode": "TUI",
        "countryCode": "BF",
        "latitude": "38.88868400",
        "longitude": "-77.00471900"
    },
    {
        "name": "Ioba",
        "isoCode": "IOB",
        "countryCode": "BF",
        "latitude": "11.05620340",
        "longitude": "-3.01757120"
    },
    {
        "name": "Sourou",
        "isoCode": "SOR",
        "countryCode": "BF",
        "latitude": "13.34180300",
        "longitude": "-2.93757390"
    },
    {
        "name": "Séno",
        "isoCode": "SEN",
        "countryCode": "BF",
        "latitude": "14.00722340",
        "longitude": "-0.07467670"
    },
    {
        "name": "Oubritenga",
        "isoCode": "OUB",
        "countryCode": "BF",
        "latitude": "12.70960870",
        "longitude": "-1.44346900"
    },
    {
        "name": "Nayala",
        "isoCode": "NAY",
        "countryCode": "BF",
        "latitude": "12.69645580",
        "longitude": "-3.01757120"
    },
    {
        "name": "Gourma",
        "isoCode": "GOU",
        "countryCode": "BF",
        "latitude": "12.16244730",
        "longitude": "0.67730460"
    },
    {
        "name": "Oudalan",
        "isoCode": "OUD",
        "countryCode": "BF",
        "latitude": "14.47190200",
        "longitude": "-0.45023680"
    },
    {
        "name": "Ziro",
        "isoCode": "ZIR",
        "countryCode": "BF",
        "latitude": "11.60949950",
        "longitude": "-1.90992380"
    },
    {
        "name": "Kossi",
        "isoCode": "KOS",
        "countryCode": "BF",
        "latitude": "12.96045800",
        "longitude": "-3.90626880"
    },
    {
        "name": "Kourwéogo",
        "isoCode": "KOW",
        "countryCode": "BF",
        "latitude": "12.70774950",
        "longitude": "-1.75388170"
    },
    {
        "name": "Ganzourgou",
        "isoCode": "GAN",
        "countryCode": "BF",
        "latitude": "12.25376480",
        "longitude": "-0.75328090"
    },
    {
        "name": "Yatenga",
        "isoCode": "YAT",
        "countryCode": "BF",
        "latitude": "13.62493440",
        "longitude": "-2.38136210"
    },
    {
        "name": "Loroum",
        "isoCode": "LOR",
        "countryCode": "BF",
        "latitude": "13.81298140",
        "longitude": "-2.06651970"
    },
    {
        "name": "Bazèga",
        "isoCode": "BAZ",
        "countryCode": "BF",
        "latitude": "11.97676920",
        "longitude": "-1.44346900"
    },
    {
        "name": "Sanguié",
        "isoCode": "SNG",
        "countryCode": "BF",
        "latitude": "12.15018610",
        "longitude": "-2.69838680"
    },
    {
        "name": "Bam",
        "isoCode": "BAM",
        "countryCode": "BF",
        "latitude": "13.44613300",
        "longitude": "-1.59839590"
    },
    {
        "name": "Noumbiel",
        "isoCode": "NOU",
        "countryCode": "BF",
        "latitude": "9.84409460",
        "longitude": "-2.97755580"
    },
    {
        "name": "Kompienga",
        "isoCode": "KMP",
        "countryCode": "BF",
        "latitude": "11.52383620",
        "longitude": "0.75328090"
    },
    {
        "name": "Léraba",
        "isoCode": "LER",
        "countryCode": "BF",
        "latitude": "10.66487850",
        "longitude": "-5.31025050"
    },
    {
        "name": "Balé",
        "isoCode": "BAL",
        "countryCode": "BF",
        "latitude": "11.78206020",
        "longitude": "-3.01757120"
    },
    {
        "name": "Kouritenga",
        "isoCode": "KOT",
        "countryCode": "BF",
        "latitude": "12.16318130",
        "longitude": "-0.22446620"
    },
    {
        "name": "Poni",
        "isoCode": "PON",
        "countryCode": "BF",
        "latitude": "10.33259960",
        "longitude": "-3.33889170"
    },
    {
        "name": "Soum",
        "isoCode": "SOM",
        "countryCode": "BF",
        "latitude": "14.09628410",
        "longitude": "-1.36621600"
    },
    {
        "name": "Comoé",
        "isoCode": "COM",
        "countryCode": "BF",
        "latitude": "10.40729920",
        "longitude": "-4.56244260"
    },
    {
        "name": "Kadiogo",
        "isoCode": "KAD",
        "countryCode": "BF",
        "latitude": "12.34258970",
        "longitude": "-1.44346900"
    },
]